import { computed } from '@vue/composition-api';
import { format as formatDate } from 'date-fns';

export const useFormattedDate = ({ date, format = 'dd.MM.yyyy H:mm' }) => {
  return computed(() => formatDate(new Date(date), format));
};
